import React from 'react';
import { Link } from 'react-router-dom';
// import './classLoc.css';

const ClassLoc = ({ title, description, path, address }) => {
  return (
    <div className="class-loc">
      <h3>{title}</h3>
      <p>{description}</p>
      <ul>
        {address.map((loc, index) => (
          <li key={index}>{loc}</li>
        ))}
      </ul>
      <Link to={path} className="btn">
        Learn More
      </Link>
    </div>
  );
};

export default ClassLoc;